// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1HXO7","imageUploader":"EGiftCard_imageUploader__3w3Wi"};